import { render, staticRenderFns } from "./UserBannedModalHandler.vue?vue&type=template&id=9b146318&scoped=true&"
import script from "./UserBannedModalHandler.vue?vue&type=script&lang=js&"
export * from "./UserBannedModalHandler.vue?vue&type=script&lang=js&"
import style0 from "./UserBannedModalHandler.vue?vue&type=style&index=0&id=9b146318&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b146318",
  null
  
)

component.options.__file = "UserBannedModalHandler.vue"
export default component.exports